import React from 'react'
import StatusList from '../components/status_list'
import GroupSortBlock from '../components/group_sort_block'
import {
  VIDEO_SORTS,
  GROUP_SORT_TOPS,
  EXPLORE_SORT_CREATE_PARAMS,
  BREAKPOINT_EXTRA_SMALL,
} from '../constants'
import StatusVideoClip from '../components/status_video_clip'
import ExploreTimelinePills from '../components/explore_timelines_pills'
import { isTouch } from '../utils/is_mobile'
import VideoClipPlaceholder from '../components/placeholder/video_clip_placeholder'
import Text from '../components/text'
import { connect } from 'react-redux'
import { timelineClear, timelineFetchPaged } from '../store/timelines'
import { me } from '../initial_state'

function Wrapper({ children }) {
  const isTouchable = isTouch()
  const isXS = window.innerWidth <= BREAKPOINT_EXTRA_SMALL
  const isMobile = isTouchable || isXS

  return (
    <div
      className={[_s.d, _s.w100PC, _s.displayGrid].join(' ')}
      style={{
        gridGap: '5px',
        gridTemplateColumns: `repeat(auto-fill, minmax(${!isMobile ? 180 : 120}px, 1fr))`,
      }}
    >
      {children}
    </div>
  )
}

const timelineId = 'video-clips'

class ProVideosClipsTimeline extends React.PureComponent {

  state = {
    onlyFollowing: false,
  }

  handleOnSetFollowing = (value) => {
    this.setState({ onlyFollowing: value })
    this.props.onClearTimeline()
    this.props.onFetchTimeline(value)
  }

  render() {
    const { onlyFollowing } = this.state

    const isTouchable = isTouch()
    const isXS = window.innerWidth <= BREAKPOINT_EXTRA_SMALL
    const isMobile = isTouchable || isXS

    return (
      <div className={[_s.d, _s.w100PC].join(' ')}>
        { isXS && <ExploreTimelinePills /> }
        <div className={!isMobile ? undefined : [_s.d, _s.px15, _s.pt10].join(' ')}>
          <div className={[_s.d, _s.flexRow, _s.aiCenter].join(' ')}>
            {
              !!me &&
              <div className={[_s.d, _s.flexRow, _s.aiCenter, _s.jcCenter, _s.pb15].join(' ')}>
                <button
                  className={[_s.d, _s.mr10, _s.bgTransparent, _s.outlineNone, _s.cursorPointer].join(' ')}
                  onClick={() => this.handleOnSetFollowing(false)}
                >
                  <Text
                    weight='medium'
                    color={onlyFollowing ? 'secondary' : 'primary'}
                    className={onlyFollowing ? undefined : _s.underline}
                  >
                      All
                  </Text>
                </button>
                <Text size='small' color='secondary' className={_s.mr10}>·</Text>
                <button
                  className={[_s.d, _s.mr10, _s.bgTransparent, _s.outlineNone, _s.cursorPointer].join(' ')}
                  onClick={() => this.handleOnSetFollowing(true)}
                >
                  <Text
                    weight='medium'
                    color={!onlyFollowing ? 'secondary' : 'primary'}
                    className={!onlyFollowing ? undefined : _s.underline}
                  >
                    Following
                  </Text>
                </button>
                <Text size='small' color='secondary' className={_s.mr5}>·</Text>
              </div>
            }
            <GroupSortBlock sorts={VIDEO_SORTS} timelineId={timelineId} />
          </div>
        </div>
        
        <div className={!isMobile ? undefined : [_s.d, _s.px5].join(' ')}>
          <StatusList
            noInjections
            usePages
            timelineId={timelineId}
            endpoint={`/api/v2/timelines/video?media_type=clips`}
            emptyMessage='No clips found'
            sorts={VIDEO_SORTS}
            topSorts={GROUP_SORT_TOPS}
            createParams={EXPLORE_SORT_CREATE_PARAMS}
            component={StatusVideoClip}
            placeholder={VideoClipPlaceholder}
            onlyFollowing={onlyFollowing}
            wrapper={Wrapper}
          />
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  const timeline = !!timelineId ? state.getIn(['timelines', timelineId]) : null
  return {
    sortByValue: !!timeline ? timeline.get('sortByValue') : undefined,
  }
}

const mapDispatchToProps = (dispatch, sortByValue) => ({
  onClearTimeline: () => dispatch(timelineClear(timelineId)),
  onFetchTimeline: (onlyFollowing) => {
    const expandOpts = {
      onlyFollowing,
      sorts: VIDEO_SORTS,
      topSorts: GROUP_SORT_TOPS,
      usePages: ['top', 'hot'].indexOf(sortByValue) > -1,
      createParams: EXPLORE_SORT_CREATE_PARAMS,
    }
    expandOpts.endpoint = '/api/v2/timelines/video?media_type=clips'
    dispatch(timelineFetchPaged(timelineId, expandOpts))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ProVideosClipsTimeline)